import { Button, Label, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import golfUser from '../../../../../../../assets/images/golf-user.png';
import golfCourse from '../../../../../../../assets/images/golf-course.svg';
import timer from '../../../../../../../assets/images/timer.svg';

const ModifyBookingModal = ({ onClose, currentSelectedBooking, handleMofifyOption }) => {
  return (
    <Modal isOpen={true} centered className="modify-option-modal">
      <ModalHeader toggle={onClose} className="border-0 pb-0">
        <p className="fw-semibold fs-16">
          Modify Booking –{' '}
          <span style={{ textDecoration: 'underline' }} className="fs-14 fw-normal">
            {currentSelectedBooking?.bookingId}
          </span>
        </p>
      </ModalHeader>

      <ModalBody className="pt-3">
        <div className="d-grid gap-3">
          {currentSelectedBooking?.actions?.includes('modify_player') && (
            <ActionButton
              icon={<img src={golfUser} style={{ width: '40px' }} />}
              label="Modify Player"
              onClick={() => handleMofifyOption('MODIFY_PLAYER')}
            />
          )}

          {currentSelectedBooking?.actions?.includes('reject-slot') && (
            <ActionButton
              icon={<img src={timer} style={{ width: '40px' }} />}
              label="Suggest New Slot"
              onClick={() => handleMofifyOption('SUGGEST_SLOT')}
            />
          )}

          {currentSelectedBooking?.actions?.includes('suggest_new_golf_course') && (
            <ActionButton
              icon={<img src={golfCourse} style={{ width: '40px' }} />}
              label="Suggest New Courses"
              onClick={() => handleMofifyOption('SUGGEST_COURSE')}
            />
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

const ActionButton = ({ icon, label, onClick }) => (
  <Button onClick={onClick} color="light" className="d-flex align-items-center gap-3 shadow-sm py-2 rounded-3 text-start" style={{ fontWeight: 600 }}>
    <span style={{ fontSize: '1.5rem' }}>{icon}</span>
    <span>{label}</span>
  </Button>
);

export default ModifyBookingModal;
